/**
 * What a stored body is, told from its bytes.
 *
 * The API does not say: bodies are content-addressed blobs, and one trace
 * mixes JSON (our API, many airlines) with XML (NDC airlines). XML starts
 * with '<' after any whitespace; anything else is treated as JSON, which the
 * viewer pretty-prints when it parses and shows untouched when it does not.
 */
export function sniffBodyFormat(body: string): 'xml' | 'json' {
  return body.trimStart().startsWith('<') ? 'xml' : 'json';
}
